(function() {
  const blockedUrls = [
    '/blogs/news/tagged/makeup',
    '/blogs/news/tagged/lipsticks',
    '/blogs/news/tagged/foundations',
    '/blogs/news/tagged/eyes',
    '/blogs/news/tagged/beauty',
    '/collections/lipsticks/products/matte-perfection-lipstick',
    '/collections/makeup-lips/products/matte-perfection-lipstick',
    '/collections/compact-powders/products/wet-dry-compact-powder',
    '/collections/compact-powders/products/moon-duchess-velvet-matte-ultra-light-compact-powder',
    '/collections/makeup-face/products/wet-dry-compact-powder',
    '/collections/makeup-face/products/moon-duchess-velvet-matte-ultra-light-compact-powder',
    '/collections/makeup/products/wet-dry-compact-powder',
    '/collections/makeup/products/matte-perfection-lipstick',
    '/collections/makeup/products/moon-duchess-velvet-matte-ultra-light-compact-powder',
    '/collections/moon-duchess/products/matte-perfection-lipstick',
    '/collections/moon-duchess/products/moon-duchess-velvet-matte-ultra-light-compact-powder',
    '/collections/tamaraa/products/wet-dry-compact-powder',
    '/collections/makeup-bridal/products/wet-dry-compact-powder',
    '/collections/makeup-bridal/products/matte-perfection-lipstick',
    '/collections/best-seller/products/wet-dry-compact-powder',
    '/collections/best-seller/products/matte-perfection-lipstick',
    '/collections/best-seller/products/moon-duchess-velvet-matte-ultra-light-compact-powder'
  ];

  const currentPath = window.location.pathname;
  if (blockedUrls.includes(currentPath)) {
    window.location.href = '/404';
  }
})();
